import { CATEGORY_MODEL_CLASS_NAME } from 'models/daos/category/constants'
import { PRODUCT_QUANTITY_MODEL_CLASS_NAME } from 'models/daos/product-quantity/constants'
import { PROMO_CODE_MODEL_CLASS_NAME } from 'models/daos/promo-code/constants'
import { TAG_MODEL_CLASS_NAME } from 'models/daos/tag/constants'

const PRODUCT_MODEL_CLASS_NAME = 'Product'

const PRODUCT_MODEL_KEY = {
  CONTENT: 'content',
  DATA: 'data',
  DESCRIPTION: 'description',
  FEATURED_AT: 'featuredAt',
  IMG: 'img',
  NAME: 'name',
  PRICE: 'price',
  PUBLISHED_AT: 'publishedAt',
  LIMITED_AT: 'limitedAt',
  SHARE_IMG: 'shareImg',
  SLUG: 'slug',
  TAGS: 'tags',
  TITLE: 'title',
  TYPE: 'type',
  CATEGORIES: 'categories',
  OPTIONS: 'options',
  PRODUCT_QUANTITIES: 'productQuantities',
  PROMO_CODES: 'promoCodes',
  RECOMMENDED: 'recommended'
}

const PRODUCT_MODEL_KEY_POINTER = PRODUCT_MODEL_KEY.SLUG

/**
 * A mapping of attributes that the data Object can have.
 * @type {Object{string}}
 */
const PRODUCT_MODEL_DATA = {
  WEIGHT: 'weight',
  COLOR: 'color',
  IMAGE1: 'image1',
  IMAGE2: 'image2',
  IMAGE3: 'image3',
  IMAGE4: 'image4',
  IMAGE5: 'image5',
  IMAGE6: 'image6',
  IMAGE7: 'image7',
  IMAGE8: 'image8',
  IMAGE9: 'image9',
  IMAGE10: 'image10',
  OPTION: 'option',
  OPTION1: 'option1',
  OPTION2: 'option2',
  OPTION3: 'option3',
  OPTION4: 'option4',
  OPTION5: 'option5',
  OPTION6: 'option6',
  OPTION7: 'option7',
  OPTION8: 'option8',
  OPTION9: 'option9',
  OPTION10: 'option10',
  VIDEO: 'video'
}

const PRODUCT_MODEL_DATA_MEDIA_KEYS = [
  PRODUCT_MODEL_DATA.IMAGE1,
  PRODUCT_MODEL_DATA.IMAGE2,
  PRODUCT_MODEL_DATA.IMAGE3,
  PRODUCT_MODEL_DATA.IMAGE4,
  PRODUCT_MODEL_DATA.IMAGE5,
  PRODUCT_MODEL_DATA.IMAGE6,
  PRODUCT_MODEL_DATA.IMAGE7,
  PRODUCT_MODEL_DATA.IMAGE8,
  PRODUCT_MODEL_DATA.IMAGE9,
  PRODUCT_MODEL_DATA.IMAGE10,
  PRODUCT_MODEL_DATA.VIDEO
]

const PRODUCT_MODEL_DATA_SEPARATOR = ','
/**
 * A mapping of key to type id.
 * @type {Object}
 */
const PRODUCT_MODEL_TYPE = {
  STRINGER: 1,
  TANK_TOP: 2,
  JOGGERS: 3,
  LEGGINGS: 4,
  SHORTS: 5,
  HOODIE: 6,
  HAT: 7,
  POSTER: 8,
  MINI_RESISTANCE_BANDS: 9,
  RESISTANCE_BAND: 10
}

/**
 * A mapping of product type to human readable label.
 * @type {Object}
 */
const PRODUCT_MODEL_TYPE_LABEL = {
  [PRODUCT_MODEL_TYPE.STRINGER]: 'Stringer',
  [PRODUCT_MODEL_TYPE.TANK_TOP]: 'Tank Top',
  [PRODUCT_MODEL_TYPE.HOODIE]: 'Hoodie',
  [PRODUCT_MODEL_TYPE.JOGGERS]: 'Joggers',
  [PRODUCT_MODEL_TYPE.LEGGINGS]: 'Leggings',
  [PRODUCT_MODEL_TYPE.SHORTS]: 'Shorts',
  [PRODUCT_MODEL_TYPE.HAT]: 'Hat',
  [PRODUCT_MODEL_TYPE.MINI_RESISTANCE_BANDS]: 'Mini Resistance Band',
  [PRODUCT_MODEL_TYPE.RESISTANCE_BAND]: 'Resistance Band'
}

/**
 * A mapping of key to a list of labels.
 * @type {Object}
 */
const PRODUCT_MODEL_KEY_SELECT_LABEL = {
  [PRODUCT_MODEL_KEY.TYPE]: PRODUCT_MODEL_TYPE_LABEL
}

/**
 * Sizes available for the products of type clothes.
 * @type {Object}
 */
const PRODUCT_MODEL_SIZE = {
  XS: 'xs',
  S: 's',
  M: 'm',
  L: 'l',
  XL: 'xl',
  XXL: 'xxl',
  ONE: 'one'
}

/**
 * Colors available for the products.
 * @type {Object}
 */
const PRODUCT_MODEL_COLOR = {
  BLACK: 'black',
  GREY: 'grey',
  LIGHT_GREY: 'light grey',
  RED: 'red',
  WHITE: 'white'
}

const PRODUCT_MODEL_REGEX = {
  SIZE_GUIDE: /size guide/gi
}

/**
 * A mapping of instance's key to range validation.
 * @type {Object}
 */
const PRODUCT_MODEL_VALIDATOR = {
  [PRODUCT_MODEL_KEY.CATEGORIES]: [
    1,
    3
  ],
  [PRODUCT_MODEL_KEY.DESCRIPTION]: [
    120,
    160
  ],
  [PRODUCT_MODEL_KEY.NAME]: [
    3,
    100
  ],
  [PRODUCT_MODEL_KEY.OPTIONS]: [
    0,
    5
  ],
  [PRODUCT_MODEL_KEY.RECOMMENDED]: [
    0,
    5
  ],
  [PRODUCT_MODEL_KEY.SLUG]: [
    2,
    12
  ],
  [PRODUCT_MODEL_KEY.TAGS]: [
    3,
    12
  ],
  [PRODUCT_MODEL_KEY.TITLE]: [
    5,
    60
  ]
}

const PRODUCT_MODEL_PLACEHOLDER = {
  [PRODUCT_MODEL_KEY.TITLE]: 'The Product Title',
  [PRODUCT_MODEL_KEY.DESCRIPTION]: 'This product will help you get happier.',
  [PRODUCT_MODEL_KEY.TAGS]: 'Product, Happiness, Joy',
  [PRODUCT_MODEL_KEY.IMG]: 'https//cdn.gymaholic.co/store/women/21-how-to-become-happy/1-how-to-become-happy.jpg',
  [PRODUCT_MODEL_KEY.SHARE_IMG]: 'https//cdn.gymaholic.co/store/women/21-how-to-become-happy/share-how-to-become-happy-1.jpg',
  [PRODUCT_MODEL_KEY.SLUG]: 'classic-black-stringer',
  [PRODUCT_MODEL_KEY.CATEGORIES]: 'men',
  [PRODUCT_MODEL_KEY.RECOMMENDED]: '10, 15, `productId`',
  [PRODUCT_MODEL_KEY.OPTIONS]: '1, 2, `productId`',
  [PRODUCT_MODEL_KEY.PUBLISHED_AT]: false,
  [PRODUCT_MODEL_KEY.FEATURED_AT]: false,
  [PRODUCT_MODEL_KEY.LIMITED_AT]: false,
  [PRODUCT_MODEL_KEY.TYPE]: PRODUCT_MODEL_TYPE.HAT,
  [PRODUCT_MODEL_KEY.NAME]: 'Gymaholic Stringer',
  [PRODUCT_MODEL_KEY.CONTENT]: 'Amazing stringer.',
  [PRODUCT_MODEL_KEY.PRICE]: '25',
  [PRODUCT_MODEL_KEY.PRODUCT_QUANTITIES]: 's:30, m:40, l:10, `size`:`quantity`',
  [PRODUCT_MODEL_KEY.DATA]: 'color:red, images:additional-img-1.jpg additional-img-2.jpg, video:video.mp4, `attr`:`value`',
  [PRODUCT_MODEL_KEY.PROMO_CODES]: 'value:expireInDays'
}

/**
 * A mapping of property key to className.
 * @type {Object}
 */
const PRODUCT_MODEL_ASSOCIATION = {
  [PRODUCT_MODEL_KEY.CATEGORIES]: CATEGORY_MODEL_CLASS_NAME,
  [PRODUCT_MODEL_KEY.OPTIONS]: 'Product',
  [PRODUCT_MODEL_KEY.PRODUCT_QUANTITIES]: PRODUCT_QUANTITY_MODEL_CLASS_NAME,
  [PRODUCT_MODEL_KEY.PROMO_CODES]: PROMO_CODE_MODEL_CLASS_NAME,
  [PRODUCT_MODEL_KEY.RECOMMENDED]: 'Product',
  [PRODUCT_MODEL_KEY.TAGS]: TAG_MODEL_CLASS_NAME
}

export {
  PRODUCT_MODEL_CLASS_NAME,
  PRODUCT_MODEL_KEY,
  PRODUCT_MODEL_KEY_SELECT_LABEL,
  PRODUCT_MODEL_KEY_POINTER,
  PRODUCT_MODEL_DATA,
  PRODUCT_MODEL_DATA_MEDIA_KEYS,
  PRODUCT_MODEL_DATA_SEPARATOR,
  PRODUCT_MODEL_TYPE,
  PRODUCT_MODEL_SIZE,
  PRODUCT_MODEL_COLOR,
  PRODUCT_MODEL_REGEX,
  PRODUCT_MODEL_VALIDATOR,
  PRODUCT_MODEL_PLACEHOLDER,
  PRODUCT_MODEL_ASSOCIATION
}
